import { Input as AntdInput } from "antd";
import ReactInputMask from "react-input-mask";
import styles from "./index.module.scss";

type InputProps = {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  mask?: string;
  className?: string;
  [key: string]: any;
};

export const Input = ({
  label,
  value,
  onChange,
  mask,
  className,
  ...props
}: InputProps) => {
  return (
    <label className={styles.label}>
      <div className={styles.title}>{label}</div>
      {mask ? (
        //@ts-ignore
        <ReactInputMask
          className={`${className || ""} ${
            styles.input
          } ant-input css-dev-only-do-not-override-tchc97 ant-input-outlined`}
          mask={mask}
          value={value}
          onChange={onChange}
          {...props}
        />
      ) : (
        <AntdInput
          className={`${className || ""} ${styles.input}`}
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
    </label>
  );
};
